export const k2500K2700Bongo03Products = [
  {
    id: 'k2500-1',
    name: 'BON039',
    description: 'HEAD LAMP',
    partNumber: 'OK6B0-51040B L / CM6B6-51030B R',
    price: 48000,
    image: 'https://public.readdy.ai/ai/img_res/3ba4ee8a71a1e373648fe159f0729512.jpg',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-2',
    name: 'BON040',
    description: 'TAIL LAMP',
    partNumber: 'OK60A-51160D L/H / OK80A-51150D R/H',
    price: 44000,
    image: 'https://readdy.ai/api/search-image?query=truck%20tail%20lamp%20light%20assembly%20red%20lens%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-taillamp&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-3',
    name: 'BON041',
    description: 'FOG LAMP',
    partNumber: 'OK6B6-52500',
    price: 36000,
    image: 'https://readdy.ai/api/search-image?query=truck%20fog%20lamp%20light%20assembly%20round%20shape%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-foglamp&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-4',
    name: 'BON042',
    description: 'GRILLE',
    partNumber: 'OK6B0-50710B',
    price: 66000,
    image: 'https://readdy.ai/api/search-image?query=truck%20front%20grille%20black%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-grille&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-5',
    name: 'BON043',
    description: 'BUMPER',
    partNumber: 'OK5B0-50031',
    price: 86000,
    image: 'https://readdy.ai/api/search-image?query=truck%20front%20bumper%20chrome%20metal%20automotive%20part%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-bumper&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-6',
    name: 'BON044',
    description: 'SIDE STEP',
    partNumber: '-',
    price: 52000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20step%20running%20board%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-sidestep&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-7',
    name: 'BON045',
    description: 'FENDER',
    partNumber: '0K6M7-52911 R / 0K6M7-52921 L',
    price: 96000,
    image: 'https://readdy.ai/api/search-image?query=truck%20fender%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-fender&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  },
  {
    id: 'k2500-8',
    name: 'BON046',
    description: 'PANEL',
    partNumber: 'OK6B0-52310B / OK6B0-52310A',
    price: 48000,
    image: 'https://readdy.ai/api/search-image?query=truck%20body%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=k2500-panel&orientation=squarish',
    category: 'KIA K2500 K2700 BONGO 03',
    inStock: true
  }
];
